import { FC } from "react";
import { CaretDownSolid, CaretUpSolid } from "@/icons";

type SortDirection = "ascending" | "descending" | null;

type SortableColumnHeaderProps = {
  label: string;
  sortDirection?: SortDirection;
  isSortable?: boolean;
  onSort?: (direction: SortDirection) => void;
};

export const SortableColumnHeader: FC<SortableColumnHeaderProps> = ({
  label,
  sortDirection = null,
  isSortable = true,
  onSort,
}) => {
  const handleClick = () => {
    if (!isSortable || !onSort) return;

    // Cycle through: ascending -> descending -> null
    const nextDirection: SortDirection =
      sortDirection === null
        ? "ascending"
        : sortDirection === "ascending"
          ? "descending"
          : null;

    onSort(nextDirection);
  };

  const baseClasses =
    "px-3 sm:py-2 py-3 sm:text-body-m text-body-s font-bold text-headline whitespace-nowrap text-left";

  if (!isSortable) {
    return <th className={baseClasses}>{label}</th>;
  }

  return (
    <th
      aria-sort={
        sortDirection === "ascending"
          ? "ascending"
          : sortDirection === "descending"
            ? "descending"
            : "none"
      }
    >
      <button
        type="button"
        onClick={handleClick}
        className={`${baseClasses} hover:bg-swdc-silver-300 active:bg-swdc-cool-gray-200 group focus-visible:outline-swdc-blue-400 flex w-full items-center -outline-offset-2 transition-colors focus-visible:outline-2`}
      >
        {label}
        <span className="ml-auto opacity-100 transition-opacity">
          {/* Up/Down arrow */}
          {!sortDirection && (
            <span className="flex flex-col -space-y-1.5">
              <CaretUpSolid width={16} height={16} fill="#111" />
              <CaretDownSolid width={16} height={16} fill="#111" />
            </span>
          )}
          {/* Up arrow */}
          {sortDirection === "ascending" && (
            <CaretUpSolid width={16} height={16} fill="#111" />
          )}
          {/* Down arrow */}
          {sortDirection === "descending" && (
            <CaretDownSolid width={16} height={16} fill="#111" />
          )}
        </span>
      </button>
    </th>
  );
};
